<template>
    <div>
        <section>
            <div class="container">
                <div class="text-title">ACCA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>-Approved Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> Software</div>
                <p>
                    HeatCAD and LoopCAD are ACCA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>-Approved for Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span>
                    residential heating and cooling load calculations. The <b>MJ8 Editions</b> of these programs have been
                    specifically designed for the newest Manual J Standard (8th Edition, Version 2.50) and have undergone
                    rigorous testing and review to ensure compliance and to attain the ACCA-Approved
                    status. <a href="http://www.acca.org/standards/software/" target="_blank">Click here for ACCA's listing of approved software</a>.
                </p>
                <div class="row justify-center items-center" :class="{'q-mb-xl' : screenSize.lt.sm}">
                    <div class="col-xs-12 col-sm-auto text-center">
                        <img class="img-acca" :src="require('@/assets/img/content/acca-powered.png')">
                    </div>
                    <div class="col-xs-12 col-sm-auto q-gutter-md">
                        <div class="row justify-center">
                            <img class="img-logo" :src="require('@/assets/img/logos/product/loopcad-mj8.png')">
                        </div>
                        <div class="row justify-center">
                            <img class="img-logo" :src="require('@/assets/img/logos/product/heatcad-mj8.png')">
                        </div>
                    </div>
                </div>
                <p>
                    The implementations of Manual J in HeatCAD and LoopCAD are the advanced standard-compliant
                    calculations (not the Abridged Edition limited version). Our programs offer advanced
                    calculations and options such as block, room and peak loads, AED calculations and
                    graphs, October cooling load evaluations, and standard-compliant reports. And the
                    custom Manual J Review step provides an easy and fast way to check key data and
                    settings in your project design.
                </p>
                <p>
                    Users of the <b>MJ8 Editions</b> are strongly encouraged to purchase
                    a copy of the Manual J standard to use in conjunction with the software. In ACCA's
                    words...
                </p>

                <p class="q-ma-lg">
                    "Software is a powerful and useful tool, but it is not magic. If <b>Manual J</b>
                    software is not used correctly it will produce an inaccurate and misleading answer, and those
                    that have not studied <b>Manual J</b> will not know the difference. <i>[ACCA Manual J 8th Edition, Section 2-5]"</i>
                </p>

                <p>
                    The Manual J Standard also includes important limitations and a defined scope of
                    applicability. It is critical that you understand what these limitations are and
                    how they apply to your work. A good starting point are ACCA's <b>"Do's and Don'ts"</b>
                    (Section 2-3), but a thorough understanding of the entire Manual J standard is required
                    for the proper use of these programs.
                </p>
                <p>
                    Visit the <a href="http://www.acca.org/store/" target="_blank">ACCA Online Store</a>
                    for purchasing information for the
                    Manual J standard.
                </p>
                <p>
                    The following highlights key features in the <b>MJ8 Editions</b> for
                    both HeatCAD and LoopCAD. For a detailed comparison of features refer to the
                    <router-link to="/product/heatcad#features">HeatCAD Features</router-link> page or the
                    <router-link to="/product/loopcad#features">LoopCAD Features</router-link> page.
                </p>
            </div>
        </section>

        <features :productLine="acca" />
    </div>
</template>
<script>
    import features from '@/components/ProductFeatures'
    import { ACCA } from '@/plugins/acca'
    export default {
        name: 'acca',
        components: {
            features,
        },
        data() {
            return {
                acca: ACCA,
            }
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 55px;
        }

        .img-acca {
            max-height: 250px;
        }
    }
</style>
